import { Link } from 'react-router-dom';
import { serverDisplayName, serverUrl } from '../utils/siteContext';

type HomeServerCardProps = {
    serverSlug: 'frostreaver' | 'fangbreaker';
    accent: 'frost' | 'fang';
};

function HomeServerCard({ serverSlug, accent }: HomeServerCardProps) {
    const serverName = serverDisplayName(serverSlug);
    const resourceHunterUrl = serverUrl(serverSlug, '/resource-hunter');
    const rankingsUrl = serverUrl(serverSlug, '/rankings');
    const reportsUrl = serverUrl(serverSlug, '/reports');
    const logoSrc = `/${accent}-active.svg`;

    return (

        <div className="home-server-card__brand">
            <img src={logoSrc} alt={`${serverName}.zone`} className='ms-auto me-auto' />
        </div>

    );
}

export function HomePage() {
    return (
        <main className="main-content" id="main-content">

            <div className="content-wrapper py-5">
                <div className="row g-4 align-items-stretch">
                    <div className="col-lg-4 offset-lg-2">
                        <HomeServerCard serverSlug="frostreaver" accent="frost" />
                    </div>
                    <div className="col-lg-4 ">
                        <HomeServerCard serverSlug="fangbreaker" accent="fang" />
                    </div>
                </div>
                <div className="text-center my-5 mb-lg-5">
                    <p className="text-uppercase text-info fw-semibold small mb-2">EverQuest TLP Resource Hunter Daily Bonus Tracker, Combat Analytics, and Parse Rankings</p>
                    <h1 className="visually-hidden">Frostreaver.zone &amp; Fangbreaker.zone</h1>
                    <p className="lead mx-auto mb-0 home-landing-hero__copy">
                        Track daily resource hunter bonuses, browse raid reports, compare rankings, and follow progression for both Frostreaver & Fangbreaker.
                    </p>
                    <div className="d-flex flex-column flex-md-row justify-content-center mt-5 gap-5 my-5">
                        <Link className="btn btn-lg btn-outline-light" to="/resource-hunter">Resource Hunter Tracker</Link>
                        <Link className="btn btn-lg btn-outline-light" to="/rankings">View Raid Rankings</Link>
                        <Link className="btn btn-lg btn-outline-light" to="/client">Download fzClient</Link>
                    </div>
                    <hr className='my-4' />
                    <h2 className='h3'>Community Showcase: Vaniki Bros Acheivement Co.</h2>
                    <p className='lead mx-auto home-landing-hero__copy'>If you haven't already, check out the Vaniki Bros to get all of your Vaniki acheivement claimable items. These items are an absolute game changer for a fresh character, and the Bros make it incredible easy to get them all in one quick sitting. I have personally run with them recently and I could not be any happier with the service. Check out the details to see what they can do for you.
                    <div className="d-flex flex-row justify-content-center gap-5 mt-5 ">
                        <div><Link className='btn btn-lg btn-outline-light' to="/vaniki-bros">Vaniki Bros Details</Link></div>
                        <div><a href="https://discord.gg/5MYn63QvDs" className="btn btn-lg btn-outline-light">Vaniki Bros Discord</a></div>
                    </div>
                    </p>
            
                </div>
            </div>

        </main>
    );
}
